<template>
  <page>
    <div class="bg-color box">
      <div class="back-order-page">
        <div class="order-title">
          <h3 class="color-33 ft-14">商品信息</h3>
        </div>
        <div class="pic-box" v-for="(item, index) in goodsList" :key="index">
          <div class="checked" v-if="query.type !== 3">
            <van-checkbox
              v-model="item.isSelected"
              :value="item.goodsId"
              checked-color="#fc4c00"
            ></van-checkbox>
          </div>
          <div class="goodsImg"><img :src="item.skuThumb" alt="" /></div>
          <div class="card-msg">
            <p class="card-name">{{ item.goodsName }}</p>
            <p class="card-num">￥{{ item.shopPrice }}X{{ item.goodsNum }}</p>
            <div class="card-date">
              <span class="num">可售后数量：{{ item.behindBackRefundNumber }}</span>
            </div>

            <div class="money-number">
              <span class="pic-price">￥{{ (item.money * item.refundNumber).toFixed(2) }}</span>
              <div class="count-step" v-if="query.type !== 3">
                <span class="minus minus-grey" v-if="item.refundNumber <= 1"></span>
                <span class="minus" v-else @click="item.refundNumber--"></span>
                <van-field
                  class="cc-cart--number"
                  v-model="item.refundNumber"
                  maxlength="3"
                  @keyup="goodsNumberKeyup(item)"
                  @blur="updateGoodsNum(item)"
                />
                <span
                  class="push"
                  v-if="item.refundNumber < item.maxlength"
                  @click="item.refundNumber++"
                ></span>
                <span class="push minus-grey" v-else></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="apply-box margin-t-10">
        <div class="order-title ft-14">
          <span class="color-33">申请原因</span>
          <a href="javascript:;" @click="showReasonSheet = true" class="toAdd">
            {{ reason }}
            <van-icon name="arrow" class="right-arrow" />
          </a>
        </div>
      </div>
      <!-- <van-action-sheet :round='false' safe-area-inset-bottom v-model="showTypeSheet" close-on-click-action :actions="typeReasonList" @select="onTypeSelect" /> -->
      <van-action-sheet
        :round="false"
        safe-area-inset-bottom
        v-model="showReasonSheet"
        close-on-click-action
        :actions="backReason"
        @open="showReasonSheet = true"
        @select="onReasonSelect"
      />
      <div class="message margin-t-10">
        <van-cell-group>
          <van-field
            v-model="brief"
            rows="4"
            autosize
            label="问题描述"
            type="textarea"
            maxlength="500"
            placeholder="请描述申请售后服务的具体原因，以便您的售后订单处理哦～"
            show-word-limit
          />
        </van-cell-group>
      </div>
      <div class="check-add margin-t-10" v-if="query.type === 2">
        <div class="order-title">
          <h3 class="color-33 ft-14">请核对您的换货收货信息</h3>
        </div>
        <div @click="handleSetAddress">
          <div class="site-item" v-if="choiceAddrs">
            <div class="msg">
              <span class="color-33">{{ choiceAddrs.consignee }}</span>
              <span class="color-99">{{ choiceAddrs.mobile }}</span>
              <i class="defalut" v-if="choiceAddrs.default">默认</i>
            </div>
            <div class="msg">
              {{ choiceAddrs.provinceCn }}{{ choiceAddrs.cityCn }}{{ choiceAddrs.districtCn
              }}{{ choiceAddrs.address }}
            </div>
            <div class="edit-box">
              <van-icon class="cc-arrow" name="arrow" />
            </div>
          </div>
          <van-cell class="no-addr" v-else title="点击添加收货地址" is-link />
        </div>
      </div>
      <div class="tips">
        <span>
          售后过程中有任何问题可咨询在线客服
          <br />
          或拨打客服热线：0755-27357035
        </span>
      </div>
      <div class="submit-box">
        <van-button type="danger" @click="submitOrder" class="submit-btn">提交</van-button>
      </div>
    </div>
  </page>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      query: {},
      choiceAddrs: null,
      // 商品列表
      goodsList: null,
      showReasonSheet: false,
      backReason: [],
      reason: '',
      brief: ''
    };
  },
  methods: {
    onReasonSelect(item) {
      this.reason = item.name;
    },
    // 数量处理
    goodsNumberKeyup(item) {
      item.refundNumber = item.refundNumber.toString().replace(/[^\d.]/g, '');
    },
    updateGoodsNum(item) {
      if (!parseInt(item.refundNumber)) {
        item.refundNumber = 1;
      }
      if (item.refundNumber > item.maxlength) {
        item.refundNumber = item.maxlength;
      }
    },
    // end
    // 初始化商品相关
    applyBackOrder() {
      const queryData = this.$route.query;
      this.$service
        .getBackRefundOrder({
          orderCode: queryData.orderSn,
          refundType: queryData.stauts,
          sourceFlag: queryData.sourceFlag || 'mall'
        })
        .then((res) => {
          const data = res.data;
          this.goodsList = data.orderGoodsList.map((item) => {
            const goods = item.goods;
            return {
              isSelected: parseInt(queryData.id) === item.id,
              goodsName: item.goodsName,
              skuThumb: goods.skuThumb,
              goodsPrice: item.goodsPrice,
              shopPrice: goods.marketPrice,
              goodsNum: item.goodsNum,
              orderId: item.id,
              totalNumber: item.behindBackRefundNumber,
              refundNumber: item.behindBackRefundNumber,
              behindBackRefundNumber: item.behindBackRefundNumber,
              goodsId: item.goodsId,
              money: (item.totalMoney / item.goodsNum).toFixed(2),
              totalMoney: item.totalMoney
            };
          });
          this.backReason = data.backReason.map((item) => {
            return {
              name: item.reason,
              refundType: item.refundType
            };
          });
          // this.reason = data.backReason
        });
    },
    // 获取修改地址相关
    handleSetAddress() {
      this.$router.push({
        name: 'address',
        query: {
          isChoose: 1,
          orderGoodsId: this.$route.query.orderGoodsId,
          orderSn: this.query.orderSn,
          type: this.query.type
        }
      });
    },
    queryAddress() {
      // if (addressId) {
      //   this.$service
      //     .getSiteNew({
      //       id: addressId
      //     })
      //     .then((res) => {
      //       this.choiceAddrs = res.data;
      //       console.log('this.choiceAddrsthis.choiceAddrs', this.choiceAddrs);
      //     });
      // } else {

        this.$service.getAreasListNew().then((res) => {
          const data = res.data;
          if (data.length) {
            this.choiceAddrs = data[0];
          }
        });

      // }
    },
    // end
    // 提交售后
    submitOrder() {
      const queryData = this.query;
      let params = {
        brief: this.brief,
        orderCode: queryData.orderSn,
        reason: this.reason,
        refundGoodsList: [],
        refundType: queryData.stauts,
        sourceFlag: queryData.sourceFlag,
        refundModel: 1, //退换货方式: 1 买家自寄，2 上门取件
        addressList: {
          receive: null
        }
      };
      let orderGoodsId = null;
      this.goodsList.map((item) => {
        if (item.isSelected) {
          if (!orderGoodsId) orderGoodsId = item.orderGoodsId;
          params.refundGoodsList.push({
            goodsId: item.goodsId,
            goodsNumber: item.refundNumber
          });
        }
      });

      if (this.query.stauts === 2) {
        params.addressList.receive = this.choiceAddrs.addressId;
      }
      const reg = /^[\u4E00-\u9FA5\s+a-zA-Z0-9_#＃、()（）-]*$/;
      if (params.refundGoodsList.length === 0) {
        this.$toast('请选择售后商品');
        return false;
      } else if (!this.reason) {
        this.$toast('请选择申请原因后提交！');
        return false;
      } else if (!reg.test(this.brief)) {
        this.$toast('问题描述只能输入中文、数字、字母、空格、# - _');
        return false;
      }
      this.$service.saveBackRefund(params).then(res => {
        this.$toast('提交成功！')
        this.$router.replace({
          name: 'back-order-detail',
          query: {
            orderGoodsId: queryData.orderGoodsId,
            orderSn: queryData.orderSn,
            returnType: '1'
          }
        })
      })
    }
  },
  mounted() {
    const queryData = this.$route.query;
    this.query = queryData;
    this.query.type = queryData.type;
    this.query.stauts = queryData.stauts;
    this.applyBackOrder();
    if (queryData.stauts === 2) {
      this.queryAddress();
    }
  },
  filters: {}
};
</script>
<style lang="stylus" scoped>
.no-addr span {
  color: #999;
}

.box {
  height: 100vh;
  padding-bottom: 100px;
}

.back-order-page {
  background: #fff;
}

.pic-box {
  height: 79px;
  padding: 10px 15px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;

  .checked {
    width: 20px;
    height: 20px;
    margin: 30px 10px 0 0;

    >>>.van-icon-success {
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      vertical-align: top;
      font-size: 16px;
      // color #fc4c00
    }
  }

  .goodsImg {
    width: 80px;
    height: 80px;
    background: #eee;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .card-msg {
    flex: 1;
    margin-left: 10px;
    width: 255px;
    position: relative;
    height: 80px;

    .card-name {
      color: #333;
      font-size: 14px;
      font-weight: 600;
      margin: 0;
      line-height: 20px;
      max-height: 40px;
      overflow: hidden;
    }

    .card-num {
      color: #666;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
    }

    .card-date {
      font-size: 12px;
      line-height: 18px;
      height: 18px;
      position: absolute;
      left: 0;
      bottom: 0;

      .num {
        color: #999;
        float: left;
      }
    }
  }
}

.apply-box {
  background: #fff;
}

.order-title {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  color: #999;
  position: relative;
}

.order-title .toAdd {
  float: right;
  color: #333;
  width: 150px;
  height: 44px;
  text-align: right;
  margin-right: 15px;
}

>>> .right-arrow {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-top: 10px;
  text-align: center;
  line-height: 24px;
  position: absolute;
  top: 0px;
  right: 5px;
}

.check-add {
  background: #fff;
}

.check-add .site-item {
  background: #ffffff;
  padding: 14px 15px;
  position: relative;
  overflow: hidden;
}

.site-item .msg {
  color: #333;
  font-size: 14px;
  width: 290px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 30px;
  line-height: 30px;
}

.defalut {
  width: 30px;
  height: 18px;
  line-height: 18px;
  font-size: 10px;
  background: #FB4C03;
  font-style: normal;
  color: #fff;
  margin-left: 10px;
  border-radius: 4px 4px;
  display: inline-block;
  text-align: center;
}

.edit-box {
  position: absolute;
  right: 10px;
  top: 26px;
  width: 24px;
  height: 24px;
}

.cc-arrow {
  color: #999;
  width: 24px;
  height: 24px;
  font-size: 20px;
  text-align: center;
  line-height: 24px;
  display: block;
}

.tips {
  margin-top: 30px;
  font-size: 12px;
  color: #B2B2B2FF;
  text-align: center;
}

.submit-box {
  text-align: center;
}

.submit-box .submit-btn {
  width: 335px;
  background: #FF3400;
  border-radius: 8px 8px;
  margin-bottom: 20px;
}

.money-number {
  position: absolute;
  right: 0;
  bottom: 0;
  text-align: center;
  // position absolute
  // right 15px
  // bottom 15px
  // margin 30px 0 0 0px
}

.money-number .pic-price {
  font-size: 14px;
  color: #FC4C00;
  font-weight: 600;
  height: 20px;
  line-height: 20px;
  display: block;
}

.count-step {
  width: 98px;
  height: 27px;
}

.count-step .minus, .count-step .push {
  width: 26px;
  height: 25px;
  display: block;
  float: left;
  position: relative;
  border: solid 1px #333;
}

.count-step .minus {
  border-right: 0 none;
  border-radius: 3px 0 0 3px;
}

.count-step .push {
  border-left: 0 none;
  border-radius: 0 3px 3px 0;
}

.count-step .minus:after, .count-step .push:after, .count-step .push:before {
  background: #333;
  position: absolute;
  content: '';
}

.count-step .minus:after, .count-step .push:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 12px;
}

.count-step .push:before {
  width: 1px;
  height: 14px;
  top: 6px;
  left: 13px;
}

.count-step .minus-grey {
  border-color: #ccc;
}

.count-step .minus-grey:after, .count-step .minus-grey:before {
  background: #ccc;
}

.cc-cart--number {
  padding: 0;
  border: 1px solid #333;
  float: left;
  width: 42px;
  height: 27px;
}

.cc-cart--number >>>.van-field__control {
  line-height: 25px;
  text-align: center;
}
</style>
